/**
 * Helpers de renderizado JSX reutilizables entre páginas.
 * Separados de entityHelpers.js para mantener ese módulo como utilidades puras.
 */
import React from 'react';
import HighlightedText from '../components/common/HighlightedText';

/**
 * Renderiza celda de equipo con código como título y marca/modelo como subtítulo
 *
 * @param {Object|null} equipo - Objeto equipo con codigo, marca, modelo
 * @param {string} searchTerm - Término de búsqueda para highlighting
 * @returns {JSX.Element}
 */
export function renderEquipoCell(equipo, searchTerm) {
  if (!equipo) return <span className="text-muted">-</span>;
  return (
    <div>
      <strong><HighlightedText text={equipo.codigo || ''} searchTerm={searchTerm} /></strong>
      <div className="text-muted">
        <HighlightedText text={[equipo.marca, equipo.modelo].filter(Boolean).join(' ')} searchTerm={searchTerm} />
      </div>
    </div>
  );
}
